export default {
  email: (v) => /.+@.+/.test(v) || "* Not a valid email address",
  required: (v) => !!v || "* This field is required",
};
